import { classNames } from 'libs/react';
import { Money } from 'components/Money';
import { React } from 'libs/react';
import { Text } from 'components/Text';
import { Icon } from 'components/Icon';
import { useEffect, useRef } from 'react';
import { useDealConfiguratorContext } from '../DealConfigureScreen';
import { useUser } from 'components/user/UserProvider';
import { useModal } from 'components/modal/ModalStack';
import { useQuoteContext } from 'modules/public/quote/QuoteScreen';
import { useDealTaxBreakdown } from '../hooks/useDealTaxBreakdown';
import { DealFinancialDetailsModal } from './modal/DealFinancialDetailsModal';
import './DealSummaryPanelStatement.scss';
import { useAccount } from 'components/account/AccountProvider';
/**
 * @component DealSummaryPanelStatement
 * @since 1.0.0
 */
export function DealSummaryPanelStatement(props) {
    const { style, deal, editable } = Object.assign({ style: 'normal', editable: false }, props);
    const user = useUser();
    const modal = useModal();
    const account = useAccount();
    let dealerColumn = true;
    if (account.tag === 'clubpiscine' || account.tag === 'groupenadeau') {
        dealerColumn = false;
    }
    const { discountRep, setSubtotal, setTotal, updateDealField } = useDealConfiguratorContext();
    const quoteContext = useQuoteContext();
    const { subTotal, otherFeesTotal, total, taxes, appliedTaxes, discountValue, costTotal, marginPercent, adjustedSubtotal } = useDealTaxBreakdown(deal, discountRep);
    const lastTaxAmountRef = useRef(null);
    const setSubtotalRef = useRef(setSubtotal);
    const setTotalRef = useRef(setTotal);
    const updateDealFieldRef = useRef(updateDealField);
    setSubtotalRef.current = setSubtotal;
    setTotalRef.current = setTotal;
    updateDealFieldRef.current = updateDealField;
    useEffect(() => {
        setSubtotalRef.current(adjustedSubtotal);
    }, [adjustedSubtotal]);
    useEffect(() => {
        setTotalRef.current(total);
        if (quoteContext) {
            quoteContext.setDealTotal(total);
        }
        const taxAmount = taxes.toString();
        if (lastTaxAmountRef.current !== taxAmount) {
            lastTaxAmountRef.current = taxAmount;
            updateDealFieldRef.current('taxAmount', taxAmount, 'number');
        }
    }, [total, taxes, quoteContext]);
    /**
     * @function onFinancialDetailsPress
     * @since 1.0.0
     * @hidden
     */
    function onFinancialDetailsPress() {
        modal.present({
            style: 'dialog',
            title: t('Financial details'),
            picto: 'file-invoice-dollar',
            className: 'deal-financial-details-modal',
            modal: React.createElement(DealFinancialDetailsModal, { deal: deal })
        });
    }
    const className = classNames('deal-summary-panel-statement', 'deal-summary-panel-statement--' + style, props.className);
    return (React.createElement("div", { className: className },
        React.createElement("div", { className: "deal-summary-panel-statement-row deal-summary-panel-statement-row--subtotal" },
            React.createElement("div", { className: "deal-summary-panel-statement-row-label" }, t('Subtotal')),
            React.createElement("div", { className: "deal-summary-panel-statement-row-value" },
                React.createElement(Money, { value: subTotal + (otherFeesTotal !== null && otherFeesTotal !== void 0 ? otherFeesTotal : 0) }))),
        discountValue > 0 && (React.createElement("div", { className: "deal-summary-panel-statement-row deal-summary-panel-statement-row--discount" },
            React.createElement("div", { className: "deal-summary-panel-statement-row-label" },
                t('Discount'),
                (deal === null || deal === void 0 ? void 0 : deal.discountType) === 'PERCENTAGE' && ` (${deal.discount}%)`),
            React.createElement("div", { className: "deal-summary-panel-statement-row-value" },
                `- `,
                React.createElement(Money, { value: discountValue })))),
        appliedTaxes.length > 0 ? (appliedTaxes.map((tax) => (React.createElement("div", { key: tax.id, className: "deal-summary-panel-statement-row" },
            React.createElement("div", { className: "deal-summary-panel-statement-row-label" },
                tax.title,
                " (",
                tax.rate,
                "%)"),
            React.createElement("div", { className: "deal-summary-panel-statement-row-value" },
                React.createElement(Money, { value: tax.amount })))))) : (React.createElement("div", { className: "deal-summary-panel-statement-row" },
            React.createElement("div", { className: "deal-summary-panel-statement-row-label" }, t('Tax')),
            React.createElement("div", { className: "deal-summary-panel-statement-row-value" },
                React.createElement(Money, { value: 0 })))),
        React.createElement("div", { className: "deal-summary-panel-statement-row deal-summary-panel-statement-row--bigtotal" },
            React.createElement("div", { className: "deal-summary-panel-statement-row-label" },
                t('Total'),
                editable && (React.createElement(Icon, { className: "deal-summary-panel-statement-financial-details-picto", value: "file-invoice-dollar", tooltip: t('View financial details'), onClick: onFinancialDetailsPress }))),
            React.createElement("div", { className: "deal-summary-panel-statement-row-total" },
                React.createElement(Money, { value: total })),
            React.createElement(Text, { value: deal === null || deal === void 0 ? void 0 : deal.currency.code, className: "deal-summary-panel-statement-currency" })),
        user.isContactUser() && dealerColumn && (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "deal-summary-panel-statement-dealer-price" },
                React.createElement("div", { className: "deal-summary-panel-statement-row-label" }, t('Your partner price')),
                React.createElement("div", { className: "deal-summary-panel-statement-row-total" },
                    React.createElement(Money, { value: costTotal + (otherFeesTotal !== null && otherFeesTotal !== void 0 ? otherFeesTotal : 0) })),
                React.createElement(Text, { value: deal === null || deal === void 0 ? void 0 : deal.currency.code, className: "deal-summary-panel-statement-currency" })),
            React.createElement("div", { className: "deal-summary-panel-statement-margin" },
                React.createElement("div", { className: "deal-summary-panel-statement-row-label" }, t('Margin')),
                React.createElement("div", { className: "deal-summary-panel-statement-row-total" },
                    marginPercent.toFixed(1),
                    "%"))))));
}
